import { render } from "./ReserveCar.vue?vue&type=template&id=47a64ec8"
import script from "./ReserveCar.vue?vue&type=script&lang=js"
export * from "./ReserveCar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__